import { render, staticRenderFns } from "./public-account.vue?vue&type=template&id=66d4c8dc&scoped=true"
import script from "./public-account.vue?vue&type=script&lang=js"
export * from "./public-account.vue?vue&type=script&lang=js"
import style0 from "./public-account.vue?vue&type=style&index=0&id=66d4c8dc&prod&scoped=true&lang=less"
import style1 from "./public-account.vue?vue&type=style&index=1&id=66d4c8dc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d4c8dc",
  null
  
)

export default component.exports